import { makeAutoObservable, observable, runInAction } from 'mobx'

import { ProjectType } from '../enum/ProjectType.enum'
import { RootStore } from './RootStore'
import { getAPIMonitoringOrganizationOverviewAPI } from '../api/controlCenter/organizationOverview.service'

export type StatusSeriesData = {
  total: number
  [statusCode: string]: number | 0
}

export type ProjectAPIOverviewData = {
  projectId: string
  projectName: string
  projectType: ProjectType
  series200: StatusSeriesData
  series300: StatusSeriesData
  series400: StatusSeriesData
  series500: StatusSeriesData
  totalAPIs: number
  failedAPIs: number
  mostFailedApiDetails: {
    urlTemplate: string
    count: number
  } | null
  slowestApiDetails: {
    urlTemplate: string
    responseTimeInMilliseconds: number
  } | null
}

export class CCApiMonitoringStore {
  apiOverviewData: ProjectAPIOverviewData[]
  error: string | null
  loading: boolean

  constructor(private rootStore: RootStore) {
    this.apiOverviewData = []
    this.error = null
    this.loading = false
    makeAutoObservable(this, {
      apiOverviewData: observable
    })
  }

  setApiOverviewData = (data: ProjectAPIOverviewData[]) => {
    this.apiOverviewData = data
  }

  setLoading = (loading: boolean) => {
    this.loading = loading
  }

  setError = (error: string | null) => {
    this.error = error
  }

  get hasData() {
    return this.apiOverviewData.length > 0
  }
}
